"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedToWriteTempFiles = exports.UnparsableRequirementError = exports.RequiredPackagesMissingError = exports.EmptyManifestError = exports.PythonPluginErrorNames = void 0;
var PythonPluginErrorNames;
(function (PythonPluginErrorNames) {
    PythonPluginErrorNames["EMPTY_MANIFEST_ERROR"] = "EMPTY_MANIFEST_ERROR";
    PythonPluginErrorNames["REQUIRED_PACKAGES_MISSING_ERROR"] = "REQUIRED_PACKAGES_MISSING_ERROR";
    PythonPluginErrorNames["UNPARSABLE_REQUIREMENT_ERROR"] = "UNPARSABLE_REQUIREMENT_ERROR";
    PythonPluginErrorNames["FAILED_TO_WRITE_TEMP_FILES"] = "FAILED_TO_WRITE_TEMP_FILES";
})(PythonPluginErrorNames = exports.PythonPluginErrorNames || (exports.PythonPluginErrorNames = {}));
class EmptyManifestError extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.EMPTY_MANIFEST_ERROR;
    }
}
exports.EmptyManifestError = EmptyManifestError;
class RequiredPackagesMissingError extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.REQUIRED_PACKAGES_MISSING_ERROR;
    }
}
exports.RequiredPackagesMissingError = RequiredPackagesMissingError;
class UnparsableRequirementError extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.UNPARSABLE_REQUIREMENT_ERROR;
    }
}
exports.UnparsableRequirementError = UnparsableRequirementError;
class FailedToWriteTempFiles extends Error {
    constructor(message) {
        super(message);
        this.name = PythonPluginErrorNames.FAILED_TO_WRITE_TEMP_FILES;
    }
}
exports.FailedToWriteTempFiles = FailedToWriteTempFiles;
//# sourceMappingURL=errors.js.map